import React from 'react';
import Autopara from './Autopara';

const images = [
  'https://www.shutterstock.com/image-photo/man-use-laptop-cloud-computing-600nw-2018729366.jpg',
  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQTfpR1a3Ii6xxqHpKbCWGVj8s5Og_26CuNXg58KoW2H-zbXM8Wr5cX_VBoOJMDElxqF_I&usqp=CAU',
  'https://diengcyber.com/wp-content/uploads/2025/04/cloud-di-genggaman-tangan-2.jpg',
];

const paragraphText = `
  Our cloud services provide scalable infrastructure, reliable data storage, and global accessibility. 
  We specialize in deploying and managing solutions on AWS, Azure, and Google Cloud. 
  From serverless functions to containerized applications, we ensure high availability, security, and cost-efficiency.
`;

function AutoparaCloud() {
  return <Autopara images={images} text={paragraphText} />;
}

export default AutoparaCloud;
